module.exports = __webpack_public_path__ + "static/fonts/element-icons.535877f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/openSurvey/theme/fonts/element-icons.woff
// module id = QjPg
// module chunks = 1